module.exports = __webpack_public_path__ + "img/pp8.78c80e1c.png";